<span class="ag-header-cell-text" (click)="toggleSort()">
  {{params.displayName}} 
  <img [src]="imgSrc" alt="">
</span>
